import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import SunEditor from "suneditor-react";
import "./chat.css";
const AdminAgenda = (props) => {
  const handleEditorChange = (content) => {
    props.setMeetingChat(content);
  };
  console.log("props", props);
  return (
    <>
      <div className={`popup-outer ${props.show ? "show-popup" : ""}`}>
        <div className="popup-container feedback-popup">
          <div className="popup-header">
            <div className="popup-heading">
              Agenda
              <img
                src="../assets/icons/close.svg"
                alt=""
                className="close-btn"
                onClick={props.handleClose}
              />
            </div>
          </div>
          <div className="popup-body chatOuterr scrollbar adminAgendaPopup">
            <div className="chatOuter scrollbar">
              {props?.getAllAgenda &&
                props?.getAllAgenda?.MeetingAgendas?.map((res, i) => (
                  <React.Fragment key={i}>
                    {res.Student && (
                      <div className="chatLeftOutr">
                        <div className="chatLeft">
                          <div className="chatHeading">
                            {res?.Student?.firstName} {res?.Student?.lastName}
                          </div>
                          <div className="chatMsgOutr">
                            {/* <p className="chatMsg">{res.reply}</p> */}
                            <div
                              className="chatMsg"
                              dangerouslySetInnerHTML={{
                                __html: res.reply,
                              }}
                            />
                            {/* <label className="chatTime">10:00am</label> */}
                          </div>
                        </div>
                      </div>
                    )}
                    {res.User && (
                      <div className="chatRightOutr">
                        <div className="chatRight">
                          <div className="chatHeading">
                            {res?.User?.firstName} {res?.User?.lastName}
                          </div>
                          <div className="chatMsgOutr">
                            {/* <p className="chatMsg">{res.reply}</p> */}
                            <div
                              className="chatMsg"
                              dangerouslySetInnerHTML={{
                                __html: res.reply,
                              }}
                            />
                            {/* <label className="chatTime">10:00am</label> */}
                          </div>
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminAgenda;
